<template>
  <!-- 登入尾部 -->
  <div class="login_footer">
    <ul class="footer_box">
      <li>關於台易購</li>
      <li>｜</li>
      <li>平台使用協議</li>
      <li>｜</li>
      <li>支付服務協議</li>
      <li class="Copyright">Powered By Taiyigou Copyright © 2018-2019 All Rights Reserved</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LoginFooter',
  props: {
  },
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  */
  .login_footer {
    box-sizing: border-box;
    height: 40px;
    border-top: 6px solid #777777;
    color: #777777;
    font-size: 11px;
    line-height: 40px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1000px;
  }
  .footer_box {
    display: flex;
  }
  .footer_box li {
    margin: 0vw 10px;
  }
  .Copyright {

  }
</style>
